import React, { useState, useEffect, useContext } from 'react';
import axios from '../api/axiosConfig';
import { QRCodeSVG } from 'qrcode.react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { AuthContext } from '../context/AuthContext';

const WhatsAppConfig = () => {
  const { user } = useContext(AuthContext);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [restarting, setRestarting] = useState(false);

  const fetchStatus = async () => {
    try {
      const res = await axios.get('/api/whatsapp/status');
      setStatus(res.data);
    } catch (err) {
      console.error('Error fetching whatsapp status:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
    // Poll every 5 seconds to update QR code or status
    const interval = setInterval(fetchStatus, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleRestart = async () => {
    try {
      setRestarting(true);
      await axios.post('/api/whatsapp/restart');
      alert('Comando de reinicio enviado. Espera unos segundos a que genere un nuevo QR.');
      setTimeout(fetchStatus, 3000);
    } catch (err) {
      alert('Error al reiniciar el servicio');
    } finally {
      setRestarting(false);
    }
  };

  return (
    <div className="app-layout">
      <Sidebar userRole={user?.role} />

      <div className="main-content">
        <Navbar title="📱 Configuración de Bot de WhatsApp" />

        <div className="page-content" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
          <p style={{ color: '#64748b', marginBottom: '20px' }}>
            Escanea este código QR con el celular de la empresa (sección "Dispositivos Vinculados") para activar las notificaciones automáticas del sistema.
          </p>

          <div style={{ 
            background: '#fff', 
            padding: '30px', 
            borderRadius: '12px', 
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)',
            textAlign: 'center'
          }}>
            {loading ? (
              <p>Cargando estado...</p>
            ) : (
              <>
                <div style={{ marginBottom: '20px' }}>
                  <strong>Estado de Conexión: </strong>
                  {status?.isReady ? (
                    <span style={{ color: '#10b981', fontWeight: 'bold' }}>✅ CONECTADO Y LISTO</span>
                  ) : status?.qrCodeData ? (
                    <span style={{ color: '#f59e0b', fontWeight: 'bold' }}>⏳ ESPERANDO ESCANEO...</span>
                  ) : (
                    <span style={{ color: '#ef4444', fontWeight: 'bold' }}>❌ DESCONECTADO / INICIANDO...</span>
                  )}
                </div>

                {!status?.isReady && status?.qrCodeData && (
                  <div style={{ margin: '30px 0' }}>
                    <QRCodeSVG value={status.qrCodeData} size={256} />
                    <p style={{ marginTop: '15px', fontSize: '14px', color: '#64748b' }}>
                      Apunta la cámara de WhatsApp hacia este código.
                    </p>
                  </div>
                )}

                {status?.isReady && (
                  <div style={{ margin: '30px 0', padding: '20px', background: '#d1fae5', borderRadius: '8px' }}>
                    <h3 style={{ color: '#065f46', margin: '0 0 10px 0' }}>¡Todo listo!</h3>
                    <p style={{ margin: 0, color: '#064e3b' }}>
                      El bot está funcionando correctamente y enviará notificaciones a los administradores.
                    </p>
                  </div>
                )}

                <button 
                  onClick={handleRestart} 
                  disabled={restarting}
                  style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: restarting ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  {restarting ? 'Reiniciando...' : '🔄 Generar Nuevo Código QR / Reiniciar Bot'}
                </button>
                <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '10px' }}>
                  Utiliza este botón si el código QR ya no responde o si quieres vincular otro número.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppConfig;
